 
import { call, takeLatest } from 'redux-saga/effects';
import * as api from '@api/facility';
import { actions } from './facilities.slice';
import { FacilitiesFetchAction } from './facilities.types';
import { Resp, dispatch } from '../helpers';

export function* fetchFacilitiesWorker(action: FacilitiesFetchAction) {
  try {
    const response: Resp<typeof api.fetchFacilityList> = yield call(
      api.fetchFacilityList,
      action.payload
    );
    yield dispatch(actions.fetchFacilitiesSuccess(response.data));
  } catch (error) {
    yield dispatch(actions.fetchFacilitiesFailure(error as Error));
  }
}

export function* facilitiesSaga() {
  yield takeLatest(actions.fetchFacilities.type, fetchFacilitiesWorker);
}
